
import {Validatable} from "../mixins";
import eventBus from "../event-bus";

export default Validatable.extend({
	data() {
		return {
			isFocused: false,
		};
	},
	props: {
		label: [String, Object],
		value: String,
		disabled: Boolean,
		fancy: Boolean,
		tabindex: [Number, Number],
		resize: Boolean,
		height: [Number,String],
		placeholder: String,
		autofocus: Boolean,
		disableOverflow: Boolean,
		icon: String,
		iconLeft: String,
		iconClickHandler: Function,
		iconTooltip: [String, Object],
		iconLeftTooltip: [String, Object],
		iconLeftClickHandler: Function,
		minHeight: Number,
		name: String
	},
	computed: {
		_iconClickHandler():Function | undefined{
			return this.$listeners["icon-click"] as Function || this.iconClickHandler || undefined;
		},
		_iconLeftClickHandler():Function | undefined {
			return this.$listeners["icon-left-click"] as Function || this.iconClickHandler || undefined;
		},
		iconClickable():boolean {
			return this._iconClickHandler != undefined;
		},
		iconLeftClickable():boolean {
			return this._iconLeftClickHandler != undefined;
		},
		heightNr():number{
			if (!this.height) return 0;
			if (typeof(this.height) == "number") return this.height;
			return parseInt(this.height);
		},
		heightStr():string | undefined{
			if (this.heightNr <= 0) return undefined;
			return `${this.heightNr}px`;
		},
		minHeightStyleStr():string | undefined{
			if (!this.minHeight) {
				return undefined;
			}
			return `${this.minHeight}px`;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(newValue: string) {
				if (this.$refs.textarea) {
					(this.$refs.inputElement as HTMLTextAreaElement).value = this.value;
				}
			}
		}
	},
	methods: {
		nativeInput(event:Event) {
			let target = event.target;
			if (!target) {
				return this.input("");
			}
			this.input((target as HTMLTextAreaElement).value);
		},
		input(event: string) {
			this.$emit("input", event);
		},
		onFocus(event: FocusEvent) {
			this.isFocused = true;
			this.$emit("focus", event);
		},
		onKeyup(event: KeyboardEvent) {
			this.$emit("keyup", event);
		},
		focus() {
			(this.$refs.inputElement as HTMLInputElement).focus();
		},
		onBlur(event: Event) {
			this.isFocused = false;
			this.$emit("blur", event);
		},
		onResize(){
			this.$emit("scroll-height", (this.$refs.inputElement as HTMLTextAreaElement).scrollHeight);
		},
		iconLeftClick(){
			this.focus();
			if (this._iconLeftClickHandler){
				this._iconLeftClickHandler();
			}
		},
		iconClick(){
			this.focus();
			if (this._iconClickHandler){
				this._iconClickHandler();
			}
		},
	},
	created(){
		eventBus.$on("window-resize", this.onResize);
	},
	destroyed(){
		eventBus.$off("window-resize", this.onResize);
	},
	mounted(){
		this.onResize();
		if (this.autofocus) {
			this.focus();
		}
	},
	updated(){
		this.onResize();
	}
});
